
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPPreventiveRecirculationWorkExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col">Sr No.</th>
                        <th>Date</th>
                        <th>Pump</th>
                        <th>Start Time</th>
                        <th>Stop Time</th>
                        <th>Sump Start level (Mtr.)</th>
                        <th>Sump Stop level (Mtr.)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((i) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                    <td>{i?.pumpStartDate ? moment(i?.pumpStartDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td>{i?.pumpNumber ? i?.pumpNumber : '-'}</td>
                                    <td>{i?.pumpStartTime ? i?.pumpStartTime : '-'}</td>
                                    <td>{i?.pumpStopTime ? i?.pumpStopTime : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{i?.startSumpLevel ? i?.startSumpLevel : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{i?.stopSumpLevel ? i?.stopSumpLevel : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}